export default "__VITE_ASSET__Bl38jG6J__"